import { Button, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import React, { useCallback, useState } from 'react';
import { FormReminder } from '../../../../../FileDetail/components/FormReminder';
import { TFile } from 'types/user';
import dayjs from 'dayjs';
import { createReminder } from 'services/pricing';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

type ReminderFormProps = {
  file: TFile;
  reloadFile: () => Promise<void>;
};

export const ReminderForm = ({ file, reloadFile }: ReminderFormProps) => {
  const [openModalReminder, setOpenModalReminder] = useState<boolean>(false);

  const asyncHandleAddReminder = useCallback(
    async (value: {
      date: string;
      time: string;
      note: string;
      showBailiff: boolean;
      showAdmin: boolean;
    }) => {
      if (!file?.id) return;
      const combinedDateTime = dayjs(`${value.date} ${value.time}`);

      if (!combinedDateTime.isValid()) {
        alert('Invalid date or time.');
        return;
      }

      if (combinedDateTime.isBefore(dayjs())) {
        alert('Reminder date/time must be in the future.');
        return;
      }
      if (!window.confirm('Are you sure you want to add this reminder?')) return;

      const combinedDateTimeISO = combinedDateTime.toISOString();
      await createReminder(
        {
          date: combinedDateTimeISO,
          note: value.note,
          showBailiff: value?.showBailiff,
          showAdmin: value?.showAdmin
        },
        Number(file?.id)
      );
      await reloadFile();
      setOpenModalReminder(false);
    },
    [file?.id, reloadFile]
  );
  const { asyncCallback } = useAsyncCallback(asyncHandleAddReminder, []);
  return (
    <Stack gap={'100%'}>
      <Stack flexDirection={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Typography fontSize={16} fontWeight={600} color={'#22374A'}>
          Reminder
        </Typography>
        <Button
          onClick={() => setOpenModalReminder(true)}
          style={{
            padding: '0 10px',
            width: '140px',
            background: '#22374A',
            borderRadius: '10px',
            border: '2px solid #22374A',
            color: '#fff',
            height: '32px',
            fontWeight: '600',
            fontSize: '12px',
            gap: '8px'
          }}>
          <img src={'/icons/icon_add_new.svg'} alt={'icon_delete'} width={'24px'} />
          New Reminder
        </Button>
      </Stack>
      <Stack
        style={{
          height: '200px',
          overflow: 'auto',
          width: '100%',
          borderRadius: '10px',
          border: '1px solid #A9ABAE',
          marginTop: '14px',
          padding: '10px',
          gap: 10
        }}>
        {file?.reminders?.map((item, index) => {
          return (
            <Stack key={index} flexDirection={'column'} width={'100%'}>
              <Stack flexDirection={'row'} gap={1} flex={1}>
                <Typography whiteSpace="pre-line" color={'#888'}>
                  {dayjs(item.date).format('YYYY/MM/DD hh:mm A')}{' '}
                  {`(${
                    item.showAdmin && item.showBailiff
                      ? 'Show all'
                      : item.showAdmin
                        ? 'Show admin'
                        : item.showBailiff
                          ? 'Show bailiff'
                          : 'Hidden'
                  })`}
                </Typography>
              </Stack>
              <Typography marginLeft={1} whiteSpace="pre-line">
                - {item.note}
              </Typography>
            </Stack>
          );
        })}
        <FormReminder
          onSubmit={asyncCallback}
          isOpen={openModalReminder}
          handleClose={() => setOpenModalReminder(false)}
        />
      </Stack>
    </Stack>
  );
};
